module.exports = __webpack_public_path__ + "img/vote.91339ea6.png";